// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"424":"52d1389b","513":"9155861e"}[chunkId] + ".css";
};